export default __webpack_public_path__ + "static/media/Deepiq_chart (4).50833b62.png";